import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Box } from '@mui/material';
import { type ModalProps, type OnModalCloseFn } from 'src/shared/components/Modals/types';

type CustomModalProps = {
  closeModal: OnModalCloseFn;
  withoutCloseIcon?: boolean;
} & ModalProps;

const CustomModal = ({ closeModal, CustomComponent, withoutCloseIcon, ...rest }: CustomModalProps) => {
  const handleCloseModal = () => {
    if (closeModal) closeModal();
  };

  return (
    <>
      {!withoutCloseIcon && (
        <Box display="flex" justifyContent="flex-end" sx={{ padding: '8px' }}>
          <div onClick={handleCloseModal}>
            <HighlightOffIcon />
          </div>
        </Box>
      )}
      <CustomComponent closeModal={closeModal} {...rest} />
    </>
  );
};

export default CustomModal;
